import AwardOne from "../../../assets/web/images/award-1.png";
import AwardTwo from "../../../assets/web/images/award-2.png";
import Container from "../Container";

function Award() {
  return (
    <section
      className="border py-8"
      style={{
        background: "linear-gradient(223deg, #001652 25.3%, #FE3535 119.32%)",
      }}
    >
      <Container>
        <div className="grid grid-cols-1 md:grid-cols-5 items-center">
          <div className="col-span-3">
            <div className="text-[38px] text-white">
              Fastest Growing HR Software in Bangladesh
            </div>
          </div>
          <div className="col-span-2">
            <div className="flex gap-4">
              <img src={AwardOne} alt="Award One" />
              <img src={AwardTwo} alt="Award Two" />
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
}

export default Award;
